import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ACCOUNT, API_VMS } from "../../constants";
import { openMessage } from "../slice/messageSlice";
import { getRoleList } from "./roleAction";

export const getRoleModulePage = createAsyncThunk(
  "role-module/page",
  async (param, thunkAPI) => {
    const respone = await fetch(
      `${API_ACCOUNT}/api/roleModul/list-sidebar/${param.roleId}`,
      // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + param.token,
          //    + param.token,
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
        }),
      }
    );
    if (respone.status === 200) {
      const responeResult = await respone.json();
      // console.log("as")
      return responeResult;
    } else {
      return {
        data: {
          content: [],
          totalElements: 0,
          totalPages: 0,
          last: true,
          size: 0,
          number: 0,
          numberOfElements: 0,
          first: true,
          empty: false,
        },
      };
    }
  }
);
export const getRoleModuleSidebar = createAsyncThunk(
  "role-module-side/page",
  async (param, thunkAPI) => {
    // console.log(param.token)
    const respone = await fetch(
      `${API_ACCOUNT}/api/roleModul/sidebar/${param.id}`,
      // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + param.token,
          //    + param.token,
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
        }),
      }
    );
    if (respone.status === 200) {
      const responeResult = await respone.json();
      // console.log(responeResult.data)
      let arr = [{ is_header: true }];
			responeResult.data.map((key,index) => {
				let obj = {path: '/'+linkgen(key.name) , icon:key.icon, title: key.name, id: key.modulId}
				if(key.subModul.length > 0 ){
					let objChild = []
          if(key.name === 'Sistem Manajemen Video'){
            key.subModul.map((keys, indexs)=>{
              if(keys.name === 'CCTV Langsung'){
                objChild.push({path: `http://${API_VMS}/dashboard`, title: keys.name, id: keys.modulId})
              }else{
                objChild.push({path: `http://${API_VMS}/record`, title: keys.name, id: keys.modulId})
              }
            })
          }else if(key.name === 'Master Data'){
            key.subModul.map((keys, indexs)=>{
              if(keys.name === 'Alert' || keys.name==='VMS' || keys.name==='Modul'){

              }else{
                objChild.push({path: '/'+linkgen(key.name)+'/'+linkgen(keys.name), title: keys.name, id: keys.modulId})
              }
            })
          }else{
            
            key.subModul.map((keys, indexs)=>{
              objChild.push({path: '/'+linkgen(key.name)+'/'+linkgen(keys.name), title: keys.name, id: keys.modulId})
            })
          }
					obj.children = objChild;
				}
				arr.push(obj)
			})
      // console.log("as")
      return {sidebar: arr, data: responeResult.data};
    } else {
      return {
        data: {
          content: [],
          totalElements: 0,
          totalPages: 0,
          last: true,
          size: 0,
          number: 0,
          numberOfElements: 0,
          first: true,
          empty: false,
        },
      };
    }
  }
);
export const getRoleModuleById = createAsyncThunk(
  'role-module-side/byId',
  async (param, thunkAPI) => {
    const user = JSON.parse(localStorage.getItem('user'))
    const respone = await fetch(`${API_ACCOUNT}/api/roleModul/modulId/${param.id}/roleId/${user.roleId}`, {
      method: 'get',
      headers: new Headers({
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      }),
    })
    const responeResult = await respone.json()
    // console.log("as")
    if(respone.status === 200){
      console.log(responeResult)
      return responeResult
    }
    return {data: ''}
  },
)
export const updateRoleModul = createAsyncThunk('roleModul/update', async (param, thunkAPI) => {
  const requestOptions = {
    method: 'PUT',  
    headers: {
      Authorization: 'Bearer ' + param.token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(param.data),
  }
  let response = await fetch(`${API_ACCOUNT}/api/roleModul/${param.id}`, requestOptions)
  if (response.status === 200) {
    thunkAPI.dispatch(
      openMessage({
        message: "Berhasil Mengubah",
        type: "success",
        open: true,
      })
    );
  }
  if (response.status === 400) {
    thunkAPI.dispatch(
      openMessage({
        message: "Maaf Perubahan Gagal",
        type: "danger",
        open: true,
      })
    );
  }
});
export const postRoleModule = createAsyncThunk('role-modul/post', async (param, thunkAPI) => {
  // console.log(param);
  
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + param.token ,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(param.data),
  }
  let response = await fetch(`${API_ACCOUNT}/api/role`, requestOptions)

  const responeResult = await response.json()
  let tempData = responeResult.data
  if (response.status === 200) {
    console.log(';kemari')
    for(let i=0 ; i < param.roleModule.length ; i++){
      if(!param.roleModule[i].create && !param.roleModule[i].read && !param.roleModule[i].delete && !param.roleModule[i].update){
        console.log('kesini')
      }else{

        // console.log('kesini')
          postPerModule(param.token, param.roleModule[i], tempData.id)
          for(let i=0 ; i < param.roleModule[i].subMenu.length ; i++){
            if(!param.roleModule[i].subMenu[i].create && !param.roleModule[i].subMenu[i].read && !param.roleModule[i].subMenu[i].delete && !param.roleModule[i].subMenu[i].update){

            }else{
              postPerModule(param.token, param.roleModule[i].subMenu[i], tempData.id)
            }
          }
      }
    }
    thunkAPI.dispatch(
      openMessage({ message: 'Insert Role Module Successfull', type: 'success', open: true }),
    )
    thunkAPI.dispatch(getRoleList({token: param.token}))
  }
  // .then(getApi())
}
);
async function postPerModule (token, data, id){
  console.log('ada tang kesini')
  let body = {
    roleId : id,
    modulId : data.id,
    create : data.create,
    read : data.read,
    update : data.update,
    delete : data.delete
  }
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token ,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(body),
  }
  await fetch(`${API_ACCOUNT}/api/roleModul`, requestOptions)
}

const linkgen = (str) => {
  let strLowerCase = str.toLowerCase()
  let replace = strLowerCase.replaceAll(' ', '-')
  return replace;
}